module.exports = __webpack_public_path__ + "img/L09.4fd9cdc6.jpg";